export const GTM_TAG_MAP = {
  drive: 'GTM-MF3DQJHV',
  rac: 'GTM-5NH44HCX',
};
